import {callAPI, silentInvokeAPI} from './commonBusiness';
import {SignalRHub, SignalREvent, ApiRouteMap} from '../../constants/dataEnum';
import {getLog, clearLog} from '../../lib/logHelper';

export const sendUILogToBackend = () => async (dispatch) => {
  const log = getLog();

  const result = await dispatch(silentInvokeAPI(SignalRHub.INSTRUMENT, SignalREvent.SAVE_UI_LOG, log));

  if (!result) {
    return;
  }

  clearLog();
};

export const sendError = () => async (dispatch, getState) => {
  const state = getState();
  const {configState} = state;
  const baseUrl = configState.hubHost.urlInstrumentControlLocation;

  try {
    await dispatch(sendUILogToBackend());

    const response = await callAPI('POST', baseUrl, ApiRouteMap.SEND_ERROR);

    return response;
  } catch (err) {
    return null;
  }
};

export const startSendUILogToBackendSchedule =
  (maxStackSize = 10) =>
  async (dispatch) => {
    const scheduleInterval = 5000;

    const scheduleFunc = async () => {
      try {
        const log = getLog();

        // send ui log if log count in local storage is above 80% of max log size
        // to prevent log disappear caused by auto roll over
        if (log && log.length >= Math.floor(0.8 * maxStackSize)) {
          console.log('[startSendUILogToBackendSchedule] send ui log to backend');

          await dispatch(sendUILogToBackend());
        }
      } catch (err) {
        console.log('[startSendUILogToBackendSchedule] err', err);
      }

      setTimeout(() => {
        scheduleFunc();
      }, scheduleInterval);
    };

    scheduleFunc();
  };

export const prepareDownloadLogByDate = (startDate, endDate) => async (_, getState) => {
  const state = getState();
  const {configState} = state;
  const baseUrl = configState.hubHost.urlAuthoringLocation;

  try {
    const result = await callAPI('POST', baseUrl, ApiRouteMap.PREPARE_DOWNLOAD_LOG_DATE, {startDate, endDate});

    return result;
  } catch (err) {
    return null;
  }
};

export const prepareDownloadLogByIds = (ids) => async (_, getState) => {
  const state = getState();
  const {configState} = state;
  const baseUrl = configState.hubHost.urlAuthoringLocation;

  try {
    const result = await callAPI('POST', baseUrl, ApiRouteMap.PREPARE_DOWNLOAD_LOG_IDS, ids);

    return result;
  } catch (err) {
    return null;
  }
};

export const downloadLog = (token) => async (_, getState) => {
  const state = getState();
  const {configState} = state;
  const baseUrl = configState.hubHost.urlAuthoringLocation;

  const url = `${baseUrl}/${ApiRouteMap.DOWNLOAD_LOG}/${token}`;
  const link = document.createElement('a');
  link.href = url;
  document.body.appendChild(link);
  link.click();
};

export const getLogList = () => async (_, getState) => {
  const state = getState();
  const {configState} = state;
  const baseUrl = configState.hubHost.urlAuthoringLocation;

  try {
    const result = await callAPI('GET', baseUrl, ApiRouteMap.GET_LOG_LIST);

    return result;
  } catch (err) {
    return [];
  }
};
